import React from 'react'
import PropTypes from 'prop-types'
import { CButton, CContainer } from '@coreui/react-pro'
import { isChunkLoadError } from '../utils/lazyWithRetry'

// Last line of defence for render errors. A stale-chunk failure has already had its one
// automatic reload (lazyWithRetry), so landing here means a reload is up to the user. Any
// other error used to unmount the whole app to a blank page; showing a reload is better.
class ChunkErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { error: null }
  }

  static getDerivedStateFromError(error) {
    return { error }
  }

  componentDidCatch(error, info) {
    console.error('[ChunkErrorBoundary]', error, info?.componentStack)
  }

  render() {
    const { error } = this.state
    if (!error) return this.props.children

    const stale = isChunkLoadError(error)
    return (
      <CContainer className="vh-100 d-flex flex-column justify-content-center align-items-center text-center">
        <h4 className="mb-2">{stale ? 'Vamos has been updated' : 'Something went wrong'}</h4>
        <p className="text-body-secondary mb-4">
          {stale
            ? 'A newer version is available. Reload the page to continue.'
            : 'Reload the page to continue. If this keeps happening, contact support.'}
        </p>
        <CButton color="primary" onClick={() => window.location.reload()}>
          Reload
        </CButton>
      </CContainer>
    )
  }
}

ChunkErrorBoundary.propTypes = {
  children: PropTypes.node,
}

export default ChunkErrorBoundary
